<template>
    <md-dialog :md-fullscreen="false"
               :md-active.sync="getTrust"
               :md-click-outside-to-close="false">
        <md-dialog-content>
            <get-trust-score></get-trust-score>
        </md-dialog-content>
        <md-dialog-actions>
            <md-button class="md-primary" @click="$emit('update:getTrust', false)">Close</md-button>
        </md-dialog-actions>
    </md-dialog>
</template>

<script>
    import GetTrustScore from "../views/GetTrustScore";
    export default {
        name: "get-trust-popup",
        components: {GetTrustScore},
        props: ['getTrust']
    }
</script>

<style scoped>

</style>